// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResizableCard_card__ReacC {
  width: 100%;
}

.ResizableCard_resizableCard__x9FKc {
  display: flex;
  overflow: auto;
  flex-direction: row;
}

.ResizableCard_cardHeaderNoWrap__l\\+JlV {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.ResizableCard_textTruncate__jVQcp {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ResizableCard_buttonHeaderCard__C6nHP {
  align-items: center;
  display: flex;
  gap: 0.8rem;
}

.ResizableCard_buttonIconDisabled__IQiii {
  cursor: not-allowed;
  opacity: 0.3;
  margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ResizableSection/ResizableCard/ResizableCard.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".card {\n  width: 100%;\n}\n\n.resizableCard {\n  display: flex;\n  overflow: auto;\n  flex-direction: row;\n}\n\n.cardHeaderNoWrap {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n}\n\n.textTruncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.buttonHeaderCard {\n  align-items: center;\n  display: flex;\n  gap: 0.8rem;\n}\n\n.buttonIconDisabled {\n  cursor: not-allowed;\n  opacity: 0.3;\n  margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `ResizableCard_card__ReacC`,
	"resizableCard": `ResizableCard_resizableCard__x9FKc`,
	"cardHeaderNoWrap": `ResizableCard_cardHeaderNoWrap__l+JlV`,
	"textTruncate": `ResizableCard_textTruncate__jVQcp`,
	"buttonHeaderCard": `ResizableCard_buttonHeaderCard__C6nHP`,
	"buttonIconDisabled": `ResizableCard_buttonIconDisabled__IQiii`
};
export default ___CSS_LOADER_EXPORT___;
